import ExhibitionLoginCard from "@components/Components/ExhibitionLogin/ExhibitionLoginCard";
import { getBrand } from "@components/config/helpers";
import dynamic from "next/dynamic";


//Dynamically load the home component and return it
const Page = ({data}) => {

    return (
        <>
            <ExhibitionLoginCard type="stand_builder" title="Stand Builders" />
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    try {
        if(!getBrand('EH')){
            return {notFound: true}
        }
        // const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}aboutus`);
        // const data = await req.json()

        // if(data.exception) {
        //     return {notFound: true}
        // }
    
        return {
            props: {
                
             },
        };
        
    } catch (error) {
        console.log(error)
        return {notFound: true} //404
    }
}

export default Page;
